// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__PxT1T","content":"RecentSearches_content__-AQ93"};